import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as CashPaymentBagIcon } from '../../assets/images/svg/cash-payment-bag.svg';
import themeColors from '../../assets/styles/themeColors';

const CashPaymentBagIconStyled = styled(CashPaymentBagIcon)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  fill: ${({ color }) => color || themeColors.colorBackgroundPrimaryDark};
`;

const CashPaymentBag = (props) => <CashPaymentBagIconStyled {...props} />;

CashPaymentBag.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

CashPaymentBag.defaultProps = {
  w: '62px',
  h: '62px',
};

export default CashPaymentBag;
